import storage from '../Storage/storage.js';


// const ImgURL='http://192.168.1.101:8008/imgurl/'//图片请求前缀
// const Api = 'http://192.168.1.101:8008/';



const ImgURL='http://modeag.cdusto.com:8080/imgurl/'//图片请求前缀
const Api = 'http://modeag.cdusto.com:8080/';


const Register=Api+'api/regist';
const Login=Api+'api/login';
const Addmodel=Api+'domodel/addmodel';
const LookZwZq=Api+'domodel/look_zw_zq';
const Getimglist=Api+'lookmodel/get_imglist';//周期图片列表



const Zwlxlist=Api+'lookmodel/zw_lxlist';
const NsSxList=Api+'lookmodel/ns_shilist';
const TjGxList=Api+'lookmodel/tj_gxlist'; 
const Addzwzq=Api+'domodel/addzwzq';
const Looknslist=Api+'domodel/look_ns_list';
const Deletenongshi=Api+'lookmodel/delete_nongshi';
const Modeldetail=Api+'domodel/model_detail';

const Lookzqnongshi=Api+'lookmodel/look_zqnongshi';//查看农事详情
const Updatenongshi=Api+'lookmodel/update_nongshi';//修改农事信息
const Updatechufa=Api+'lookmodel/update_chufa';//修改触发条件
const Deletechufa=Api+'lookmodel/delete_chufa';//删除触发条件

const Lookmodellist=Api+'lookmodel/lookmodellist';//模型列表
const Deletemodel=Api+'lookmodel/deletemodel';//删除模型

const Editdetaone=Api+'lookmodel/edit_deta_one';//修改模型基本信息时获取数据
const Updatemodeljb=Api+'lookmodel/update_modeljb';//修改模型基本信息
const LookAddzwzq=Api+'lookmodel/add_zwzq';//添加作物周期
const Updatezwzq=Api+'lookmodel/update_zwzq';//修改作物周期
const Deletezwzq=Api+'lookmodel/delete_zwzq';//删除作物周期




















 export default {
   storage,
   ImgURL,
   Register,
   Login,
   Addmodel,
   LookZwZq, 
   Getimglist,
   Zwlxlist,

   NsSxList,
   TjGxList,
   Addzwzq,  
   Looknslist,
   Deletenongshi,
   Modeldetail,
   Lookzqnongshi,
   Updatenongshi,
   Updatechufa,
   Deletechufa,
   Lookmodellist,
   Deletemodel,

   Editdetaone,
   Updatemodeljb,
   LookAddzwzq,
   Updatezwzq,
   Deletezwzq,
};


// WEBPACK FOOTER //
// ./src/HttpConfig/httpConfig.js